// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-container {
  padding: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.au-container h1 {
  color: #f1f5f9;
  margin-bottom: 1.5rem;
}

.au-loading {
  text-align: center;
  padding: 3rem;
  color: #94a3b8;
}

.au-message {
  padding: 0.75rem 1.25rem;
  border-radius: 6px;
  font-weight: 500;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.au-message.success {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid #10b981;
  color: #10b981;
}

.au-message.error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444;
  color: #ef4444;
}

.au-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.au-card h3 {
  color: #f1f5f9;
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
}

/* Create form */
.au-create-form {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.au-input {
  padding: 0.6rem 0.875rem;
  background: #0f172a;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 0.9rem;
  min-width: 180px;
}

.au-input:focus {
  outline: none;
  border-color: #f59e0b;
}

.au-admin-toggle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #cbd5e1;
  font-size: 0.9rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/* Table */
.au-table {
  width: 100%;
  border-collapse: collapse;
}

.au-table th {
  text-align: left;
  color: #64748b;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #334155;
}

.au-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #1e293b;
  vertical-align: middle;
}

.au-table tr:last-child td {
  border-bottom: none;
}

.au-id {
  color: #475569;
  font-size: 0.875rem;
}

.au-username {
  color: #f1f5f9;
  cursor: pointer;
  border-bottom: 1px dashed #475569;
  padding-bottom: 1px;
}

.au-username:hover {
  color: #f59e0b;
  border-bottom-color: #f59e0b;
}

.au-date {
  color: #64748b;
  font-size: 0.8rem;
}

/* Admin toggle */
.au-toggle {
  width: 40px;
  height: 22px;
  background: #334155;
  border-radius: 9999px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}

.au-toggle.on {
  background: #10b981;
}

.au-toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s;
}

.au-toggle.on .au-toggle-thumb {
  transform: translateX(18px);
}

/* Inline edit */
.au-edit-inline {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.au-input-sm {
  padding: 0.35rem 0.625rem;
  background: #0f172a;
  border: 1px solid #475569;
  border-radius: 4px;
  color: #f1f5f9;
  font-size: 0.875rem;
  min-width: 140px;
}

.au-input-sm:focus {
  outline: none;
  border-color: #f59e0b;
}

.au-btn-save {
  padding: 0.35rem 0.75rem;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}

.au-btn-cancel {
  padding: 0.35rem 0.75rem;
  background: #334155;
  color: #cbd5e1;
  border: none;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
}

/* Action buttons */
.au-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.au-btn-action {
  padding: 0.35rem 0.75rem;
  background: #334155;
  color: #f1f5f9;
  border: none;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.au-btn-action:hover {
  background: #475569;
}

.au-btn-danger {
  padding: 0.35rem 0.75rem;
  background: #7f1d1d;
  color: #fecaca;
  border: 1px solid #ef4444;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.au-btn-danger:hover {
  background: #991b1b;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminUsers.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".au-container {\n  padding: 2rem;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.au-container h1 {\n  color: #f1f5f9;\n  margin-bottom: 1.5rem;\n}\n\n.au-loading {\n  text-align: center;\n  padding: 3rem;\n  color: #94a3b8;\n}\n\n.au-message {\n  padding: 0.75rem 1.25rem;\n  border-radius: 6px;\n  font-weight: 500;\n  margin-bottom: 1.5rem;\n  font-size: 0.9rem;\n}\n\n.au-message.success {\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid #10b981;\n  color: #10b981;\n}\n\n.au-message.error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid #ef4444;\n  color: #ef4444;\n}\n\n.au-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.au-card h3 {\n  color: #f1f5f9;\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n}\n\n/* Create form */\n.au-create-form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.au-input {\n  padding: 0.6rem 0.875rem;\n  background: #0f172a;\n  border: 1px solid #475569;\n  border-radius: 6px;\n  color: #f1f5f9;\n  font-size: 0.9rem;\n  min-width: 180px;\n}\n\n.au-input:focus {\n  outline: none;\n  border-color: #f59e0b;\n}\n\n.au-admin-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: #cbd5e1;\n  font-size: 0.9rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n/* Table */\n.au-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.au-table th {\n  text-align: left;\n  color: #64748b;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 0.5rem 0.75rem;\n  border-bottom: 1px solid #334155;\n}\n\n.au-table td {\n  padding: 0.75rem;\n  border-bottom: 1px solid #1e293b;\n  vertical-align: middle;\n}\n\n.au-table tr:last-child td {\n  border-bottom: none;\n}\n\n.au-id {\n  color: #475569;\n  font-size: 0.875rem;\n}\n\n.au-username {\n  color: #f1f5f9;\n  cursor: pointer;\n  border-bottom: 1px dashed #475569;\n  padding-bottom: 1px;\n}\n\n.au-username:hover {\n  color: #f59e0b;\n  border-bottom-color: #f59e0b;\n}\n\n.au-date {\n  color: #64748b;\n  font-size: 0.8rem;\n}\n\n/* Admin toggle */\n.au-toggle {\n  width: 40px;\n  height: 22px;\n  background: #334155;\n  border-radius: 9999px;\n  position: relative;\n  cursor: pointer;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n\n.au-toggle.on {\n  background: #10b981;\n}\n\n.au-toggle-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  background: white;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n\n.au-toggle.on .au-toggle-thumb {\n  transform: translateX(18px);\n}\n\n/* Inline edit */\n.au-edit-inline {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.au-input-sm {\n  padding: 0.35rem 0.625rem;\n  background: #0f172a;\n  border: 1px solid #475569;\n  border-radius: 4px;\n  color: #f1f5f9;\n  font-size: 0.875rem;\n  min-width: 140px;\n}\n\n.au-input-sm:focus {\n  outline: none;\n  border-color: #f59e0b;\n}\n\n.au-btn-save {\n  padding: 0.35rem 0.75rem;\n  background: #10b981;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.au-btn-cancel {\n  padding: 0.35rem 0.75rem;\n  background: #334155;\n  color: #cbd5e1;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  cursor: pointer;\n}\n\n/* Action buttons */\n.au-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.au-btn-action {\n  padding: 0.35rem 0.75rem;\n  background: #334155;\n  color: #f1f5f9;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n\n.au-btn-action:hover {\n  background: #475569;\n}\n\n.au-btn-danger {\n  padding: 0.35rem 0.75rem;\n  background: #7f1d1d;\n  color: #fecaca;\n  border: 1px solid #ef4444;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n\n.au-btn-danger:hover {\n  background: #991b1b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
